import React from 'react'
import { Grid } from '@material-ui/core'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import Dot from './Dot'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  analysis: {
    borderRadius: 4,
    padding: 2
  },
  spacing: {
    marginLeft: 8
  }
}))

const AnalysisType = ({ type, title, theme, messages }) => {
  const classes = useStyles()

  return (
    <Grid item key={type} style={{ marginBottom: 10 }}>
      <Grid container wrap="nowrap">
        <Grid item xs={3}>
          <DazzedParagraph14 strong>{title}</DazzedParagraph14>
        </Grid>
        <Grid item xs={10}>
          <Grid container direction="column" spacing={1}>
            {messages
              .filter(({ condition }) => condition)
              .map(({ message, icon }, index) => (
                <Grid item key={`${type}-message${index}`}>
                  <Grid
                    container
                    alignItems="center"
                    className={classes.analysis}
                    style={{ backgroundColor: theme?.backgroundColor }}
                  >
                    <Grid item className={classes.spacing}>
                      {icon ?? <Dot color={theme?.dotColor} />}
                    </Grid>
                    <Grid item className={classes.spacing}>
                      <Grid container>
                        <Grid item key={`${type}-message${index}`}>
                          <DazzedParagraph14 strong>{message}</DazzedParagraph14>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default AnalysisType
